import { render, staticRenderFns } from "./HeadingWithIcon.vue?vue&type=template&id=92a18cf2&scoped=true"
import script from "./HeadingWithIcon.vue?vue&type=script&lang=js"
export * from "./HeadingWithIcon.vue?vue&type=script&lang=js"
import style0 from "./HeadingWithIcon.vue?vue&type=style&index=0&id=92a18cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a18cf2",
  null
  
)

export default component.exports